var map = {
	"./360video2.mp4": 35599,
	"./HomePage2.mp4": 5902,
	"./InsightXrBanner.mp4": 8349,
	"./VrPage2.mp4": 27573,
	"./bannerThumbnail/360.jpg": 84154,
	"./bannerThumbnail/360Thumb.png": 37613,
	"./bannerThumbnail/360Thumb2.jpg": 13948,
	"./bannerThumbnail/Insight-XrThumb.jpg": 5283,
	"./bannerThumbnail/ai.jpg": 21808,
	"./bannerThumbnail/blog.jpg": 90353,
	"./bannerThumbnail/blogThumb.png": 99043,
	"./bannerThumbnail/blogThumb2.jpg": 37263,
	"./bannerThumbnail/contact.jpg": 10882,
	"./bannerThumbnail/contactThumb.png": 89447,
	"./bannerThumbnail/contactThumb2.jpg": 12006,
	"./bannerThumbnail/genThumb.png": 19260,
	"./bannerThumbnail/genThumb2.jpg": 27106,
	"./bannerThumbnail/home.jpg": 99097,
	"./bannerThumbnail/homeThumb.png": 60397,
	"./bannerThumbnail/homeThumb2.jpg": 8285,
	"./bannerThumbnail/mixThumb.png": 18199,
	"./bannerThumbnail/mixThumb2.jpg": 95351,
	"./bannerThumbnail/mr.jpg": 47190,
	"./bannerThumbnail/vr.jpg": 13900,
	"./bannerThumbnail/vrThumb.png": 75628,
	"./bannerThumbnail/vrThumb2.jpg": 55372,
	"./blogVideo2.mp4": 66704,
	"./contactus2.mp4": 42858,
	"./genVideo2.mp4": 26865,
	"./img1.jpg": 61109,
	"./img2.jpg": 28390,
	"./imgnew.png": 9610,
	"./insightXR.mp4": 79670,
	"./mixed2.mp4": 40653
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84946;